/**
 * Viewport breakpoints aligned with Tailwind-style `@media (min-width: …)` /
 * CSS range `@media (width >= …)` (same thresholds).
 */
export const BREAKPOINT_REM = {
  sm: '40rem', // 640/16
  md: '48rem', // 768/16
  lg: '64rem', // 1024/16
  xl: '80rem', // 1280/16
  '2xl': '96rem', // 1536/16
} as const;

export type BreakpointName = keyof typeof BREAKPOINT_REM;

const minWidthQuery = (rem: string): string => `(min-width: ${rem})`;

export const MEDIA_QUERY_MIN_WIDTH = {
  sm: minWidthQuery(BREAKPOINT_REM.sm),
  md: minWidthQuery(BREAKPOINT_REM.md),
  lg: minWidthQuery(BREAKPOINT_REM.lg),
  xl: minWidthQuery(BREAKPOINT_REM.xl),
  '2xl': minWidthQuery(BREAKPOINT_REM['2xl']),
} as const satisfies Record<BreakpointName, string>;
